import React from "react";
import "./privacyPolicy.css";

function PrivacyPolicy({ onClose }) {
  return (
    <div className="privacy-overlay" onClick={onClose}>
      <div className="privacy-modal" onClick={(e) => e.stopPropagation()}>
        <button className="privacy-close-btn" onClick={onClose}>
          &times;
        </button>
        <h2>Terms of Service &amp; Privacy Policy</h2>
        <p className="privacy-effective">Effective Date: February 2026</p>
        <p>
          By using this application (the &ldquo;Service&rdquo;) or uploading any
          content, you agree to these terms in full. If you do not agree, do not
          use the Service.
        </p>

        <h3>1. Data Collection &amp; Usage</h3>
        <p>The Service is managed by the Operator. We collect:</p>
        <ul>
          <li>
            <strong>Visual/Photographic Information:</strong> All images you
            submit are permanently retained by the Operator.
          </li>
          <li>
            <strong>Technical Data:</strong> IP address, browser type, device
            info, and approximate location are automatically collected to help
            us understand usage patterns and improve the Service.
          </li>
        </ul>

        <h3>2. Broad License to Your Content</h3>
        <p>
          By uploading any content, you grant the Operator an{" "}
          <strong>
            unlimited, perpetual, irrevocable, worldwide, royalty-free, fully
            sublicensable, and transferable license
          </strong>{" "}
          to use, store, copy, reproduce, modify, adapt, publish, translate,
          distribute, publicly display, and create derivative works from your
          content &mdash; for any purpose, commercial or non-commercial, without
          restriction and without any obligation to notify or compensate you.
        </p>
        <p>
          <strong>This explicitly includes the right to:</strong>
        </p>
        <ul>
          <li>Share images with any third party, partner, or researcher.</li>
          <li>
            Use images to train, fine-tune, or evaluate machine learning and AI
            models for any purpose.
          </li>
          <li>
            Sell, transfer, or sublicense images to other companies or
            individuals for any purpose.
          </li>
          <li>
            Publish images publicly without attribution or prior notice to you.
          </li>
        </ul>
        <p>
          You waive any moral rights or rights of attribution with respect to
          uploaded content to the fullest extent permitted by applicable law.
        </p>

        <h3>3. Data Retention &amp; Sale of Data</h3>
        <p>
          Uploaded images and technical data are retained{" "}
          <strong>indefinitely</strong> unless a valid deletion request is
          submitted (see Section 5). The Operator{" "}
          <strong>may sell or transfer</strong> your uploaded images and
          associated technical data to third parties for monetary or other
          consideration. By using the Service, you expressly consent to this.
        </p>

        <h3>4. No Expectation of Privacy</h3>
        <p>
          All uploaded images are considered{" "}
          <strong>non-confidential and non-proprietary</strong>, and may be
          viewed by the Operator or third parties. You should have no
          expectation of privacy with respect to any content you upload. Do not
          upload images containing faces, government IDs, financial information,
          or any other sensitive personal data. The Operator is not responsible
          for any consequences arising from the upload of such content.
        </p>

        <h3>5. Deletion Requests &amp; Limitations</h3>
        <p>
          This Service does not require user accounts. Because uploaded images
          are not linked to any identity, the Operator{" "}
          <strong>
            cannot verify ownership of any submitted image and therefore cannot
            guarantee the fulfillment of deletion requests.
          </strong>
        </p>
        <p>
          If you wish to submit a deletion request, contact us at{" "}
          <a href="mailto:badge.auth@gmail.com">badge.auth@gmail.com</a> with
          the exact image you uploaded and the approximate date you used the
          Service. The Operator will make reasonable efforts to locate and
          remove it but cannot guarantee deletion. By using the Service, you
          acknowledge and accept this limitation.
        </p>

        <h3>6. Your Representations</h3>
        <p>By uploading content, you confirm that:</p>
        <ul>
          <li>You own the image or have all necessary rights to share it.</li>
          <li>
            The upload does not infringe any third party&rsquo;s intellectual
            property, privacy, or other rights.
          </li>
          <li>
            You are granting the above license freely and understand it cannot
            be revoked.
          </li>
        </ul>

        <h3>7. Disclaimer &amp; Liability</h3>
        <p>
          The Service is provided &ldquo;as-is&rdquo; for experimental purposes
          with no warranties of any kind. The Operator is not liable for
          inaccuracies in results, data loss, or any damages arising from your
          use of the Service. Your use is entirely at your own risk.
        </p>

        <button className="privacy-accept-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
